import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { DropletsIcon, TargetIcon, ShieldIcon } from 'lucide-react';
export function SolutionSection() {
  return <Section background="cream" data-id="element-203">
      <div className="text-center mb-16" data-id="element-204">
        <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-6" data-id="element-205">
          Lo que hace diferente a este plan: <br data-id="element-206" />
          <span className="text-[#C4A962] italic" data-id="element-207">El Método 3 Mapas</span>
        </h2>
        <p className="text-lg text-[#4A5D4A] max-w-2xl mx-auto" data-id="element-208">
          Este plan está diseñado para la vida real: trabajo, casa, familia,
          cansancio… y cero ganas de "sentarte a presupuestar".
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-209">
        {/* Map 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0
      }} className="p-8 rounded-2xl border bg-red-50 text-red-800 border-red-100 h-full flex flex-col" data-id="element-210">
          <div className="mb-6 bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-211">
            <DropletsIcon size={24} data-id="element-212" />
          </div>
          <h3 className="text-xl font-bold mb-4 font-serif" data-id="element-213">
            MAPA 1 — SANGRADO
          </h3>
          <p className="leading-relaxed opacity-90" data-id="element-214">
            Encuentras el dinero que se te va sin darte cuenta: fugas, cargos
            repetidos, "gastos fantasma". No para castigarte. Para recuperar
            control.
          </p>
          <p className="mt-4 pt-3 border-t border-red-200/50 text-sm font-medium italic" data-id="element-215">
            → Para encontrar dinero sin sentirte pobre.
          </p>
        </motion.div>

        {/* Map 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="p-8 rounded-2xl border bg-emerald-50 text-emerald-800 border-emerald-100 h-full flex flex-col" data-id="element-216">
          <div className="mb-6 bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-217">
            <TargetIcon size={24} data-id="element-218" />
          </div>
          <h3 className="text-xl font-bold mb-4 font-serif" data-id="element-219">MAPA 2 — ATAQUE</h3>
          <p className="leading-relaxed opacity-90" data-id="element-220">
            Ordenas tus deudas con una regla simple y aplicas una fórmula que te
            dice: qué pagar, cuánto pagar y en qué orden, sin improvisar cada
            mes.
          </p>
          <p className="mt-4 pt-3 border-t border-emerald-200/50 text-sm font-medium italic" data-id="element-221">
            → Para ver progreso en semanas, no en "algún día".
          </p>
        </motion.div>

        {/* Map 3 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="p-8 rounded-2xl border bg-amber-50 text-amber-800 border-amber-100 h-full flex flex-col" data-id="element-222">
          <div className="mb-6 bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-223">
            <ShieldIcon size={24} data-id="element-224" />
          </div>
          <h3 className="text-xl font-bold mb-4 font-serif" data-id="element-225">
            MAPA 3 — PROTECCIÓN
          </h3>
          <p className="leading-relaxed opacity-90" data-id="element-226">
            Creas un mini fondo anti-imprevistos. Porque si un imprevisto te
            regresa a la tarjeta, no es "mala suerte": era una pieza faltante.
          </p>
          <p className="mt-4 pt-3 border-t border-amber-200/50 text-sm font-medium italic" data-id="element-227">
            → Para que un mes malo no te borre el avance.
          </p>
        </motion.div>
      </div>

      {/* Objection block */}
      <div className="mt-16 bg-[#2D3B2D] text-[#FDF8F0] p-8 md:p-12 rounded-3xl text-center relative overflow-hidden" data-id="element-228">
        <div className="absolute top-0 left-0 w-32 h-32 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-229" />
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-230" />

        <div className="relative z-10 max-w-2xl mx-auto" data-id="element-231">
          <h3 className="text-2xl md:text-3xl font-serif mb-6" data-id="element-232">
            "Pero yo ya sé lo básico…"
          </h3>
          <p className="text-lg opacity-90 mb-8" data-id="element-233">
            Saber no es lo que te falta. Lo que te falta es:
          </p>
          <ul className="space-y-3 text-left max-w-md mx-auto mb-8" data-id="element-234">
            <li className="flex items-start gap-3" data-id="element-235">
              <span className="w-1.5 h-1.5 bg-[#C4A962] rounded-full mt-2.5 flex-shrink-0" data-id="element-236" />
              <span className="opacity-90" data-id="element-237">
                Un plan que se sostenga cuando estás cansada
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-238">
              <span className="w-1.5 h-1.5 bg-[#C4A962] rounded-full mt-2.5 flex-shrink-0" data-id="element-239" />
              <span className="opacity-90" data-id="element-240">
                Un sistema que reduzca decisiones
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-241">
              <span className="w-1.5 h-1.5 bg-[#C4A962] rounded-full mt-2.5 flex-shrink-0" data-id="element-242" />
              <span className="opacity-90" data-id="element-243">
                Una forma de avanzar sin colapsar emocionalmente
              </span>
            </li>
          </ul>
          <p className="font-medium text-[#C4A962] text-lg" data-id="element-244">
            Este plan no compite con tu vida. Se adapta.
          </p>
        </div>
      </div>
    </Section>;
}